import { useIsFeatureEnabled } from 'src/commons/hooks';
import { WeblabedFeatures } from 'src/commons/constants';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider/InternalChromeConfigContextProvider';
import { isBtswContext, isFromBtswWc, isFromTrim } from '../utils';

export default (): boolean => {
  const isHMHIngressEnabled = useIsFeatureEnabled(
    WeblabedFeatures.HMH_IN_HEADER_QUESTION_MARK,
  );
  const isMagellanEnabled = useIsFeatureEnabled(
    WeblabedFeatures.MAGELLAN_RETAILER_HEADER,
  );
  const hasIntroWidgets = isBtswContext() || isFromBtswWc() || isFromTrim();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  return (
    isHMHIngressEnabled &&
    !(isMagellanEnabled && internalChromeConfig.retailerId) &&
    hasIntroWidgets
  );
};
